import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';

@Injectable()
export class SetupForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      companyName: [ '', Validators.required ],
      email: [ '', Validators.compose([ Validators.required, CustomValidators.email ]) ],
      firstName: [ '', Validators.required ],
      lastName: [ '', Validators.required ],
      phone: [ '', Validators.required ],
      address: [ '', Validators.required ],
      zipCode: [ '', Validators.required ],
      city: [ '', Validators.required ],
      countryCode: [ '', Validators.required ],
      cardHolder: [ '' ]
    });
  }
}
